import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      Home: "Home",
      Pages: "Pages",
      Services: "Services",
      Shop: "Shop",
      Blog: "Blog",
      Contact: "Contact",
      "Get in Touch": "Get in Touch",
      "Modern Technology": "Modern Technology",
      "Neural Networks": "Neural Networks",
      "AI Agency": "AI Agency",
      Chatbot: "Chatbot",
      Startup: "Startup",
      "AI Consulting": "AI Consulting",
      Futurism: "Futurism",
      "Hi-Tech": "Hi-Tech",
      Voiceover: "Voiceover",
      Science: "Science",
      "Creative Bureau": "Creative Bureau",
      "Video Voiceover": "Video Voiceover",
      "IT Services": "IT Services",
      "AI Devices": "AI Devices",
      "AI Solutions": "AI Solutions",
      "Image Generator": "Image Generator",
      "Content Generator": "Content Generator",
      Intro: "Intro",
      "About Us": "About Us",
      Team: "Team",
      "Creative Team": "Creative Team",
      "Team Single": "Team Single",
      Projects: "Projects",
      "Projects Grid": "Projects Grid",
      "Projects Modern": "Projects Modern",
      "Project Single": "Project Single",
      "Gallery Grid": "Gallery Grid",
      "Gallery Masonry": "Gallery Masonry",
      "Pricing Plans": "Pricing Plans",
      FAQ: "FAQ",
      Typography: "Typography",
      404: "404 Error",
      "Services Page": "Services Page",
      "Service Single": "Service Single",
      Products: "Products",
      "Single Product": "Single Product",
      "Shopping Cart": "Shopping Cart",
      Checkout: "Checkout",
      "My Account": "My Account",
      "Blog Classic": "Blog Classic",
      "Blog Grid": "Blog Grid",
      "Blog Single": "Blog Single",
      Arabic: "العربية",
      English: "English",
      Greek: "Ελληνικά",
      "Transform Your Business WIZLY": "Transform Your Business Wizzely",
      "WIZ is a privately owned Palestinian company specialized in IT & AI solution.At WIZ, we are facilitating other’s life and make it easier to achieve their business & personal goals and desires.":
        "We design, build, and launch intelligent software that drives real growth — faster operations, smarter decisions, and products your customers love.",
      "WIZ TECH: Innovation Unleashed": "WIZ TECH: Innovation Unleashed",
      "Research per year": "Research per year",
      "Explore more": "Explore more",
      "[Empowering businesses": "[Empowering businesses",
      "with smart IT solutions]": "with smart IT solutions]",
      "Key benefits and competitive advantages of our service":
        "Key benefits and competitive advantages of our service",
      "The unique selling points & advantages of our service":
        "The unique selling points & advantages of our service",
      "AI Technology": "AI Technology",
      "Emphasize the expertise and knowledge of your team in developing and implementing neural networks":
        "Emphasize the expertise and knowledge of your team in developing and implementing neural networks",
      "Tailored solutions": "Tailored solutions",
      "Mention your ability to customize solutions based on specific business requirements":
        "Mention your ability to customize solutions based on specific business requirements",
      "Latest Tools & Techniques": "Latest Tools & Techniques",
      "Highlight your use of the latest tools and techniques in neural network development":
        "Highlight your use of the latest tools and techniques in neural network development",
      "Showcase successful case studies or client testimonials":
        "Showcase successful case studies or client testimonials that demonstrate the effectiveness of your services",
      "Showcase successful case studies or client testimonials that demonstrate the effectiveness of your services":
        "Showcase successful case studies or client testimonials that demonstrate the effectiveness of your services",
      "The Neural Network experts: uniting talent for intelligent solutions":
        "The Neural Network experts: uniting talent for intelligent solutions",
      "Awesome team members": "Awesome team members",
      Manager: "Manager",
      "CEO Neuro": "CEO Neuro",
      "HR Neuro": "HR Neuro",
      "AI Programmer": "AI Programmer",
      "Introducing innovative ideas for business":
        "Introducing innovative ideas for business",
      "User stories: hear what others love about our":
        "User stories: hear what others love about our",
      "WordPress themes": "WordPress themes",
      "Exploring the world of artificial intelligence with Aiero blogging":
        "Exploring the world of artificial intelligence with Aiero blogging",
      "Our trusted collaborators in progress and success":
        "Our trusted collaborators in progress and success",
      "Join Aiero and increase your productivity":
        "Join Aiero and increase your productivity",
      "Get a Quote": "Get a Quote",
      "Case Studies": "Case Studies",
      nav_home: "nav_home",
      nav_services: "nav_services",
      nav_products: "nav_products",
      nav_case_studies: "nav_case_studies",
      nav_contact: "nav_contact",
      btn_get_in_touch: "btn_get_in_touch",
      "Explore Solutions": "Explore Solutions",
      "View Our Platforms": "View Our Platforms",
      "Who We Are": "Who We Are",
      "WIZ is a technology engineering company specializing in building intelligent, scalable, and connected systems. We combine artificial intelligence, software engineering, automation, and smart device integration to help organizations modernize their operations. Our work bridges the gap between software and hardware to deliver complete digital systems.":
        "WIZ is a technology engineering company specializing in building intelligent, scalable, and connected systems. We combine artificial intelligence, software engineering, automation, and smart device integration to help organizations modernize their operations. Our work bridges the gap between software and hardware to deliver complete digital systems.",
      "Number of systems delivered": "Number of systems delivered",
      "Programming &development": "Programming &development",
      "Achievements of our startup": "Achievements of our startup",
      "Wize Tech": "Wize Tech",
      "Active users every day": "Active users every day",
      "Professional team & tech": "Professional team & tech",
      "Watch Video": "Watch Video",
      "Our Platforms": "Our Platforms",
      "Restaurant AI System": "Restaurant AI System",
      "Hospital Monitoring Platform": "Hospital Monitoring Platform",
      "Booking SaaS Platform": "Booking SaaS Platform",
      "Pioneering future-proof engineering with WIZ expertise":
        "Pioneering future-proof engineering with WIZ expertise",
      "CORE SERVICE / INFRASTRUCTURE": "CORE SERVICE / INFRASTRUCTURE",
      "Building resilient, high-availability environments that scale automatically with your business traffic.":
        "Building resilient, high-availability environments that scale automatically with your business traffic.",
      "Scalable Cloud Infrastructure for Global Enterprises":
        "Scalable Cloud Infrastructure for Global Enterprises",
      "INNOVATION / MODERNIZATION": "INNOVATION / MODERNIZATION",
      "Modernizing Legacy Systems with Intelligent AI Layers":
        "Modernizing Legacy Systems with Intelligent AI Layers",
      "Integrating advanced AI algorithms into existing workflows to boost operational speed by 200%.":
        "Integrating advanced AI algorithms into existing workflows to boost operational speed by 200%.",
      "Legacy Systems": "Legacy Systems",
      "AI Models": "AI Models",
      "Cloud Computing": "Cloud Computing",
      DevOps: "DevOps",
      "Core Technologies": " Core Technologies",
      "AI & Machine Learning": " AI & Machine Learning",
      "Developing intelligent models for prediction, computer vision, natural language processing, and automated decision-making systems.":
        " Developing intelligent models for prediction, computer vision, natural language processing, and automated decision-making systems.",

      "Mobile Application Engineering": " Mobile Application Engineering",
      "High-performance Android and iOS applications built on reliability, scalability, and a seamless user experience.":
        " High-performance Android and iOS applications built on reliability, scalability, and a seamless user experience.",
      "Web & Cloud Platforms": " Web & Cloud Platforms",
      "Secure and scalable web systems, control panels, and cloud backends manage workflows in organizations.":
        " Secure and scalable web systems, control panels, and cloud backends manage workflows in organizations.",
      "Automation Systems": " Automation Systems",
      "Automating business processes, improving workflow, and coordinating intelligent systems":
        " Automating business processes, improving workflow, and coordinating intelligent systems",
      "IoT & Robotics Integration": " IoT & Robotics Integration",
      "Connected devices, sensor networks, and robotic solutions enable intelligent monitoring and control.":
        " Connected devices, sensor networks, and robotic solutions enable intelligent monitoring and control.",
      "AR / VR Experiences": " AR / VR Experiences",
      "Immersive digital environments for training, visualization, and active user interaction":
        " Immersive digital environments for training, visualization, and active user interaction",
      "How We Work": "How We Work",
      "View Our Capabilities": "View Our Capabilities",

      "01. Discover": "01. Discover",
      "We begin with a deep dive into your business needs and technical challenges to identify ideal opportunities for innovation.":
        "We begin with a deep dive into your business needs and technical challenges to identify ideal opportunities for innovation.",
      "02. Architect": "02. Architect",
      "We design the systems technical blueprint, focusing on scalability and the seamless connection between software and hardware.":
        "We design the systems technical blueprint, focusing on scalability and the seamless connection between software and hardware.",
      "03. Engineer": "03. Engineer",
      "The actual building phase using cutting-edge AI, IoT, and robotics technologies with the highest engineering standards.":
        "The actual building phase using cutting-edge AI, IoT, and robotics technologies with the highest engineering standards.",
      "04. Deploy": "04. Deploy",
      "Launching the system into the real-world environment while ensuring smooth integration with your existing operations.":
        "Launching the system into the real-world environment while ensuring smooth integration with your existing operations.",
      "05. Optimize": "05. Optimize",
      "Continuous monitoring and data-driven improvements to ensure your system maintains peak performance and sustainability.":
        "Continuous monitoring and data-driven improvements to ensure your system maintains peak performance and sustainability.",
      "Our Engineering": "Our Engineering",
      "Impact in Numbers": "Impact in Numbers",
      "We don't just build software; we engineer high-performance ecosystems that power industries.":
        "We don't just build software; we engineer high-performance ecosystems that power industries.",

      "Trusted by Industry": "Trusted by Industry",
      Leaders: "Leaders",
      "Powering operations for global enterprises and innovative startups.":
        "Powering operations for global enterprises and innovative startups.",

      "Ready to build something intelligent?":
        "Ready to build something intelligent?",
      "Start a Project": "Start a Project",
      "All rights reserved.": "All rights reserved.",

      "Start a Project": "Start a Project",
      "All rights reserved.": "All rights reserved.",
      "Dubai, United Arab Emirates": "Dubai, United Arab Emirates",
      "Tech Hub, Silicon Oasis": "Tech Hub, Silicon Oasis",
      "Follow Us": "Follow Us",
      X: "X",
      Instagram: "Instagram",
      "Let's Talk": "Let's Talk",
      Expertise: "Expertise",
      "Our Platforms": "Our Platforms",
      Engineering: "Engineering",
      "Case Studies": "Case Studies",
      Contact: "Contact",
      Headquarters: "Headquarters",
      Email: "Email",
      "Engineering Excellence": "Engineering Excellence",

      "Our Impact": "Our Impact",
      Case: "Case",
      Studies: "Studies",
      "Real-world engineering challenges met with intelligent, scalable solutions.":
        "Real-world engineering challenges met with intelligent, scalable solutions.",
      "Kitchen Workflow Optimization": "Kitchen Workflow Optimization",
      "Global Food Chain": "Global Food Chain",
      "Predictive Patient Monitoring": "Predictive Patient Monitoring",
      "City General Hospital": "City General Hospital",
      "SaaS Booking Infrastructure": "SaaS Booking Infrastructure",
      "Travel Tech Startup": "Travel Tech Startup",
      Client: "Client",
      Impact: "Impact",
      "Read Full Study": "Read Full Study",
      "Ready to build your success story?":
        "Ready to build your success story?",
      "Join our list of high-impact engineering partners.":
        "Join our list of high-impact engineering partners.",
      "Start a Project": "Start a Project",
      "2M+ Transactions/Mo": "2M+ Transactions/Mo",
      "99.9% Uptime": "99.9% Uptime",
      "40% Efficiency Boost": "40% Efficiency Boost",
      Automation: "Automation",
      "AI & Data": "AI & Data",
      "Cloud Systems": "Cloud Systems",
      "Our Expertise": "Our Expertise",
      Engineering: "Engineering",
      Solutions: "Solutions",
      "Restaurant AI Ecosystem": "Restaurant AI Ecosystem",
      "A complete autonomous system integrating POS, kitchen automation, and AI-driven inventory management for modern hospitality.":
        "A complete autonomous system integrating POS, kitchen automation, and AI-driven inventory management for modern hospitality.",
      "Automated Ordering": "Automated Ordering",
      "Inventory AI": "Inventory AI",
      "Fleet Management": "Fleet Management",
      "Healthcare Monitoring Platform": "Healthcare Monitoring Platform",
      "Next-generation hospital systems connecting medical devices with real-time data analytics for critical patient care.":
        "Next-generation hospital systems connecting medical devices with real-time data analytics for critical patient care.",
      "Device Integration": "Device Integration",
      "Real-time Analytics": "Real-time Analytics",
      "Data Security": "Data Security",
      "Smart Booking SaaS": "Smart Booking SaaS",
      "Scalable cloud infrastructure designed to handle high-concurrency bookings for global service providers.":
        "Scalable cloud infrastructure designed to handle high-concurrency bookings for global service providers.",
      "Cloud Scalability": "Cloud Scalability",
      "Multi-tenant Architecture": "Multi-tenant Architecture",
      "Advanced API": "Advanced API",
      "The Technical Advantage": "The Technical Advantage",
      "We don't just build apps; we architect resilient infrastructures. Using a modern stack of AI, IoT, and Cloud-native technologies, we ensure your system is future-proof.":
        "We don't just build apps; we architect resilient infrastructures. Using a modern stack of AI, IoT, and Cloud-native technologies, we ensure your system is future-proof.",
      "AI Integration": "AI Integration",
      "Cloud Native": "Cloud Native",
      "Cyber Security": "Cyber Security",
      "IoT Ready": "IoT Ready",
      Our: "Our",
      Platforms: "Platforms",
      "Scalable, intelligent, and engineering-driven software solutions designed to modernize industries.":
        "Scalable, intelligent, and engineering-driven software solutions designed to modernize industries.",
      "WizResto Platform": "WizResto Platform",
      "Hospitality & F&B": "Hospitality & F&B",
      "An AI-powered ecosystem for restaurant management, integrating kitchen automation with smart POS systems.":
        "An AI-powered ecosystem for restaurant management, integrating kitchen automation with smart POS systems.",
      "AI Inventory": "AI Inventory",
      "Kitchen Display System": "Kitchen Display System",
      "Fleet Tracking": "Fleet Tracking",
      "WizHealth Connect": "WizHealth Connect",
      "Healthcare Technology": "Healthcare Technology",
      "A secure monitoring platform that bridges medical hardware with cloud data for real-time patient analytics.":
        "A secure monitoring platform that bridges medical hardware with cloud data for real-time patient analytics.",
      "Device Connectivity": "Device Connectivity",
      "Data Encryption": "Data Encryption",
      "Remote Monitoring": "Remote Monitoring",
      "WizBooking SaaS": "WizBooking SaaS",
      "Service Sector": "Service Sector",
      "High-performance booking engine designed for scalable service providers and appointment-based businesses.":
        "High-performance booking engine designed for scalable service providers and appointment-based businesses.",
      "Real-time Availability": "Real-time Availability",
      "Payment Integration": "Payment Integration",
      "Automated Alerts": "Automated Alerts",
      "Request Demo": "Request Demo",
      "Get in Touch": "Get in Touch",
      "Have a complex engineering challenge? Let's discuss how WIZ can build your next intelligent system.":
        "Have a complex engineering challenge? Let's discuss how WIZ can build your next intelligent system.",
      "Contact Information": "Contact Information",
      "Email Us": "Email Us",
      "Call Us": "Call Us",
      Headquarters: "Headquarters",
      "Amman, Jordan": "Amman, Jordan",
      "Send a Message": "Send a Message",
      "Your Name": "Your Name",
      "Email Address": "Email Address",
      Subject: "Subject",
      "Project Details / Message": "Project Details / Message",
      "Send Proposal": "Send Proposal",
      "Get in": "Get in",
      Touch: "Touch",
admin: {
        products: "Products",
        services: "Services",
        product: "Product",
        service: "Service",
        edit: "Edit",
        add: "Add  ",
        name: "Name",
        title: "Title",
        description: "Description",
        features: "Features",
        add_feature: "Add Feature",
        image: "Product Image",
        icon: "Icon Class",
        select_image: "Select Image",
        save: "Save Changes",
        add_btn: "Add Item",
        published_items: "Published Items",
        cancel_edit: "Cancel Edit",
        confirm_title: "Are you sure?",
        confirm_desc: "This action cannot be undone.",
        cancel: "Cancel",
        delete_btn: "Delete Now",
        update_success: "Updated Successfully! ✨",
        add_success: "Added Successfully! 🚀",
        delete_success: "Item Deleted 🗑️"
      }

    },
  },
  ar: {
    translation: {
      Home: "الرئيسية",
      Pages: "الصفحات",
      Services: "الخدمات",
      Shop: "المتجر",
      Blog: "المدونة",
      Contact: "اتصل بنا",
      "Get in Touch": "تواصل معنا",
      "Modern Technology": "التكنولوجيا الحديثة",
      "Neural Networks": "الشبكات العصبية",
      "AI Agency": "وكالة ذكاء اصطناعي",
      Chatbot: "روبوتات المحادثة",
      Startup: "شركات ناشئة",
      "AI Consulting": "استشارات الذكاء الاصطناعي",
      Futurism: "المستقبليات",
      "Hi-Tech": "التقنية العالية",
      Voiceover: "التعليق الصوتي",
      Science: "العلوم",
      "Creative Bureau": "المكتب الإبداعي",
      "Video Voiceover": "التعليق الصوتي للفيديو",
      "IT Services": "خدمات تقنية المعلومات",
      "AI Devices": "أجهزة الذكاء الاصطناعي",
      "AI Solutions": "حلول الذكاء الاصطناعي",
      "Image Generator": "مولد الصور",
      "Content Generator": "مولد المحتوى",
      Intro: "مقدمة",
      "About Us": "من نحن",
      Team: "الفريق",
      "Creative Team": "الفريق الإبداعي",
      "Team Single": "تفاصيل العضو",
      Projects: "المشاريع",
      "Projects Grid": "شبكة المشاريع",
      "Projects Modern": "مشاريع عصرية",
      "Project Single": "تفاصيل المشروع",
      "Gallery Grid": "معرض الصور",
      "Gallery Masonry": "معرض الصور المنسق",
      "Pricing Plans": "خطط الأسعار",
      FAQ: "الأسئلة الشائعة",
      Typography: "تنسيق الخطوط",
      404: "خطأ 404",
      "Services Page": "صفحة الخدمات",
      "Service Single": "تفاصيل الخدمة",
      Products: "المنتجات",
      "Single Product": "تفاصيل المنتج",
      "Shopping Cart": "سلة التسوق",
      Checkout: "الدفع",
      "My Account": "حسابي",
      "Blog Classic": "المدونة التقليدية",
      "Blog Grid": "شبكة المدونة",
      "Blog Single": "تفاصيل المقال",
      Arabic: "العربية",
      English: "الإنجليزية",
      Greek: "اليونانية",
      "Transform Your Business WIZLY": "طوّر أعمالك بذكاء",
      "WIZ is a privately owned Palestinian company specialized in IT & AI solution.At WIZ, we are facilitating other’s life and make it easier to achieve their business & personal goals and desires.":
        "نصمم ونبني وننطلق ببرمجيات ذكية تحقق نمواً حقيقياً — عمليات أسرع، قرارات أذكى، ومنتجات يعشقها عملاؤك.",
      "WIZ TECH: Innovation Unleashed": "WIZ TECH: الابتكار بلا حدود",
      "Research per year": "أبحاث سنوية",
      "Explore more": "اكتشف المزيد",
      "[Empowering businesses": "تمكين الأعمال التجارية",
      "with smart IT solutions]": "[بحلول تقنية ذكية",
      "Key benefits and competitive advantages of our service":
        "الفوائد الرئيسية والمزايا التنافسية لخدمتنا",
      "The unique selling points & advantages of our service":
        "نقاط البيع الفريدة ومزايا خدمتنا",
      "AI Technology": "تكنولوجيا الذكاء الاصطناعي",
      "Emphasize the expertise and knowledge of your team in developing and implementing neural networks":
        "تسليط الضوء على خبرة ومعرفة فريقك في تطوير وتنفيذ الشبكات العصبية",
      "Tailored solutions": "حلول مخصصة",
      "Mention your ability to customize solutions based on specific business requirements":
        "أظهر قدرتك على تخصيص الحلول بناءً على متطلبات الأعمال المحددة",
      "Latest Tools & Techniques": "أحدث الأدوات والتقنيات",
      "Highlight your use of the latest tools and techniques in neural network development":
        "تسليط الضوء على استخدامك لأحدث الأدوات والتقنيات في تطوير الشبكات العصبية",
      "Showcase successful case studies or client testimonials":
        "عرض دراسات حالة ناجحة أو شهادات العملاء التي تظهر فعالية خدماتك",
      "Showcase successful case studies or client testimonials that demonstrate the effectiveness of your services":
        "عرض دراسات حالة ناجحة أو شهادات العملاء التي تظهر فعالية خدماتك",
      "The Neural Network experts: uniting talent for intelligent solutions":
        "خبراء الشبكات العصبية: توحيد المواهب من أجل حلول ذكية",
      "Awesome team members": "أعضاء فريق رائعون",
      Manager: "مدير",
      "CEO Neuro": "الرئيس التنفيذي لشركة نيورو",
      "HR Neuro": "الموارد البشرية نيورو",
      "AI Programmer": "مبرمج ذكاء اصطناعي",
      "Introducing innovative ideas for business": "تقديم أفكار مبتكرة للأعمال",
      "User stories: hear what others love about our":
        "قصص المستخدمين: اسمع ما يحبه الآخرون حول",
      "WordPress themes": "قوالب ووردبريس",
      "Exploring the world of artificial intelligence with Aiero blogging":
        "استكشاف عالم الذكاء الاصطناعي مع مدونة Aiero",
      "Our trusted collaborators in progress and success":
        "شركاؤنا الموثوقون في التقدم والنجاح",
      "Join Aiero and increase your productivity":
        "انضم إلى Aiero وزد من إنتاجيتك",
      "Get a Quote": "احصل على عرض سعر",
      "Case Studies": "دراسات الحالة",
      nav_home: "الرئيسية",
      nav_services: "الخدمات والتقنيات",
      nav_products: "المنتجات والمنصات",
      nav_case_studies: "دراسات الحالة",
      nav_contact: "اتصل بنا",
      btn_get_in_touch: "تواصل معنا",
      "Explore Solutions": "استكشف الحلول",
      "View Our Platforms": "عرض منصاتنا",
      "Who We Are": "من نحن",
      "WIZ is a technology engineering company specializing in building intelligent, scalable, and connected systems. We combine artificial intelligence, software engineering, automation, and smart device integration to help organizations modernize their operations. Our work bridges the gap between software and hardware to deliver complete digital systems.":
        "WIZ هي شركة هندسة تقنية متخصصة في بناء أنظمة ذكية وقابلة للتوسع ومترابطة. نجمع بين الذكاء الاصطناعي وهندسة البرمجيات والتشغيل الآلي والدمج مع الأجهزة الذكية لمساعدة المؤسسات على تطوير عملياتها. عملنا يسد الفجوة بين البرمجيات والأجهزة لتقديم أنظمة رقمية كاملة.",
      "Number of systems delivered": "عدد الأنظمة التي تم تسليمها",
      "Programming &development": "البرمجة والتطوير",
      "Achievements of our startup": "إنجازات شركتنا الناشئة",
      "Wize Tech": "وايز تك",
      "Active users every day": "عدد المستخدمين النشطين يومياً",
      "Professional team & tech": "فريق محترف وتقنية",
      "Watch Video": "شاهد الفيديو",
      "Our Platforms": "منصاتنا",
      "Restaurant AI System": "نظام الذكاء الاصطناعي للمطاعم",
      "Hospital Monitoring Platform": "منصة مراقبة المستشفيات",
      "Booking SaaS Platform": "منصة الحجز SaaS",
      "Pioneering future-proof engineering with WIZ expertise":
        "ريادة الهندسة المستقبلية بخبرة WIZ",
      "CORE SERVICE / INFRASTRUCTURE": "الخدمة الأساسية / البنية التحتية",
      "Building resilient, high-availability environments that scale automatically with your business traffic.":
        "بناء بيئات مقاومة وذات توفر عالٍ تتكيف تلقائيًا مع حركة عملك.",
      "Scalable Cloud Infrastructure for Global Enterprises":
        "بنية تحتية سحابية قابلة للتوسع للمؤسسات العالمية",
      "INNOVATION / MODERNIZATION": "الابتكار / التحديث",

      "Modernizing Legacy Systems with Intelligent AI Layers":
        "تحديث الأنظمة القديمة بطبقات ذكاء اصطناعي ذكية",
      "Integrating advanced AI algorithms into existing workflows to boost operational speed by 200%.":
        "دمج خوارزميات الذكاء الاصطناعي المتقدمة في سير العمل الحالية لزيادة سرعة التشغيل بنسبة 200%.",
      "Legacy Systems": "الأنظمة القديمة",
      "AI Models": "نماذج الذكاء الاصطناعي",
      "Cloud Computing": "الحوسبة السحابية",
      DevOps: "ديفوبس",
      "Core Technologies": " التقنيات الأساسية",
      "AI & Machine Learning": " الذكاء الاصطناعي وتعلم الآلة",
      "Developing intelligent models for prediction, computer vision, natural language processing, and automated decision-making systems.":
        " تطوير نماذج ذكية للتنبؤ ورؤية الحاسوب ومعالجة اللغة الطبيعية ونظام اتخاذ القرار الآلي",

      "Mobile Application Engineering": " هندسة تطبيقات الهواتف المحمولة",
      "High-performance Android and iOS applications built on reliability, scalability, and a seamless user experience.":
        " تطبيقات أندرويد وiOS عالية الأداء مبنية على الموثوقية وقابلية التوسع وتجربة مستخدم سلسة.",
      "Web & Cloud Platforms": " منصات الويب والسحابة",
      "Secure and scalable web systems, control panels, and cloud backends manage workflows in organizations.":
        " أنظمة ويب آمنة وقابلة للتوسع، ولوحات تحكم، وخلفيات سحابية تدير سير العمل في المؤسسات.",
      "Automation Systems": " نظم الأتمتة",
      "Automating business processes, improving workflow, and coordinating intelligent systems":
        " أتمتة العمليات التجارية، وتحسين سير العمل، وتنسيق الأنظمة الذكية",
      "IoT & Robotics Integration": " دمج إنترنت الأشياء والروبوتات",
      "Connected devices, sensor networks, and robotic solutions enable intelligent monitoring and control.":
        " أجهزة متصلة، وشبكات استشعار، وحلول روبوتية تمكن من المراقبة والتحكم الذكي.",
      "AR / VR Experiences": " تجارب الواقع المعزز / الواقع الافتراضي",
      "Immersive digital environments for training, visualization, and active user interaction":
        " بيئات رقمية غامرة للتدريب، والتصور، وتفاعل المستخدم النشط",
      "How We Work": " كيف نعمل",
      "View Our Capabilities": " عرض قدراتنا",

      "01. Discover": "01. الاكتشاف",
      "We begin with a deep dive into your business needs and technical challenges to identify ideal opportunities for innovation.":
        "نحن نبدأ بفحص عميق لاحتياجات عملك وتحديات تقنية لتحديد الفرص المثالية للابتكار.",
      "02. Architect": "02. التصميم",
      "We design the systems technical blueprint, focusing on scalability and the seamless connection between software and hardware.":
        "نحن نصمم المخطط التقني للأنظمة، مع التركيز على قابلية التوسع والاتصال السلس بين البرمجيات والأجهزة.",
      "03. Engineer": "03. الهندسة",
      "The actual building phase using cutting-edge AI, IoT, and robotics technologies with the highest engineering standards.":
        "مرحلة البناء الفعلية باستخدام تقنيات الذكاء الاصطناعي والإنترنت الأشياء والروبوتات بأعلى معايير الهندسة.",
      "04. Deploy": "04. النشر",
      "Launching the system into the real-world environment while ensuring smooth integration with your existing operations.":
        " إطلاق النظام في بيئة العالم الحقيقي مع ضمان التكامل السلس مع عملياتك الحالية.",
      "05. Optimize": "05. التحسين",
      "Continuous monitoring and data-driven improvements to ensure your system maintains peak performance and sustainability.":
        " مراقبة مستمرة وتحسينات تعتمد على البيانات لضمان الحفاظ على أداء النظام ومستوى استدامته.",
      "40% Efficiency Boost": "40% زيادة في الكفاءة",

      "Our Engineering": "هندستنا",
      "Impact in Numbers": "التأثير بالأرقام",
      "We don't just build software; we engineer high-performance ecosystems that power industries.":
        "نحن لا نبني فقط البرمجيات؛ بل نهندس أنظمة عالية الأداء تُشغّل الصناعات.",

      "Trusted by Industry": "موثوق به من قبل الصناعة",
      Leaders: "القادة",
      "Powering operations for global enterprises and innovative startups.":
        "توفير الدعم التشغيلي للمؤسسات العالمية والشركات الناشئة المبتكرة.",

      "Ready to build something intelligent?": "هل أنت مستعد لبناء شيء ذكي؟",
      "Start a Project": "ابدأ مشروعًا",
      "All rights reserved.": "جميع الحقوق محفوظة.",

      "Start a Project": "ابدأ مشروعًا",
      "All rights reserved.": "جميع الحقوق محفوظة.",
      "Dubai, United Arab Emirates": "دبي، الإمارات العربية المتحدة",
      "Tech Hub, Silicon Oasis": "مركز التكنولوجيا، واحة السيليكون",
      "Follow Us": "تابعنا",
      X: "X",
      Instagram: "إنستغرام",
      "Let's Talk": "لنتحدث",
      Expertise: "الخبرة",
      "Our Platforms": "منصاتنا",
      Engineering: "الهندسة",
      "Case Studies": "دراسات الحالة",
      Contact: "اتصل بنا",
      Headquarters: "المقر الرئيسي",
      Email: "البريد الإلكتروني",
      "Engineering Excellence": "تميز هندسي",
      "Our Impact": "تأثيرنا",
      Case: "دراسات",
      Studies: "الحالة",
      "Real-world engineering challenges met with intelligent, scalable solutions.":
        "تحديات هندسية واقعية تمت معالجتها بحلول ذكية وقابلة للتوسع.",
      "Kitchen Workflow Optimization": "تحسين سير العمل في المطابخ",
      "Global Food Chain": "سلسلة أغذية عالمية",
      "Predictive Patient Monitoring": "المراقبة التنبؤية للمرضى",
      "City General Hospital": "مستشفى المدينة العام",
      "SaaS Booking Infrastructure": "بنية تحتية لحجوزات SaaS",
      "Travel Tech Startup": "شركة ناشئة لتقنيات السفر",
      Client: "العميل",
      Impact: "الأثر",
      "Read Full Study": "اقرأ الدراسة كاملة",
      "Ready to build your success story?": "جاهز لبناء قصة نجاحك؟",
      "Join our list of high-impact engineering partners.":
        "انضم إلى قائمتنا من شركاء الهندسة ذوي التأثير العالي.",
      "Start a Project": "ابدأ مشروعاً",
      "2M+ Transactions/Mo": "2 مليون+ معاملة/شهرياً",
      "99.9% Uptime": "99.9% وقت التشغيل",
      "40% Efficiency Boost": "40% زيادة في الكفاءة",
      Automation: "الأتمتة",
      "AI & Data": "الذكاء الاصطناعي والبيانات",
      "Cloud Systems": "أنظمة السحابة",
      "Our Expertise": "خبراتنا",
      Engineering: "الحلول",
      Solutions: "الهندسية",
      "Restaurant AI Ecosystem": "نظام المطاعم الذكي",
      "A complete autonomous system integrating POS, kitchen automation, and AI-driven inventory management for modern hospitality.":
        "نظام مستقل متكامل يربط نقاط البيع، وأتمتة المطابخ، وإدارة المخزون المعتمدة على الذكاء الاصطناعي للضيافة الحديثة.",
      "Automated Ordering": "الطلب المؤتمت",
      "Inventory AI": "ذكاء المخزون",
      "Fleet Management": "إدارة الأسطول",
      "Healthcare Monitoring Platform": "منصة المراقبة الصحية",
      "Next-generation hospital systems connecting medical devices with real-time data analytics for critical patient care.":
        "أنظمة مستشفيات من الجيل القادم تربط الأجهزة الطبية بتحليلات البيانات الفورية لرعاية المرضى الحرجة.",
      "Device Integration": "تكامل الأجهزة",
      "Real-time Analytics": "تحليلات فورية",
      "Data Security": "أمن البيانات",
      "Smart Booking SaaS": "نظام الحجز الذكي (SaaS)",
      "Scalable cloud infrastructure designed to handle high-concurrency bookings for global service providers.":
        "بنية تحتية سحابية قابلة للتوسع مصممة للتعامل مع ضغط الحجوزات العالي لمزودي الخدمات العالميين.",
      "Cloud Scalability": "توسع سحابي",
      "Multi-tenant Architecture": "هندسة متعددة المستأجرين",
      "Advanced API": "واجهة برمجية متطورة",
      "The Technical Advantage": "الميزة التقنية",
      "We don't just build apps; we architect resilient infrastructures. Using a modern stack of AI, IoT, and Cloud-native technologies, we ensure your system is future-proof.":
        "نحن لا نبني تطبيقات فحسب؛ بل نصمم بنى تحتية مرنة. باستخدام تقنيات الذكاء الاصطناعي وإنترنت الأشياء والتقنيات السحابية، نضمن أن نظامك جاهز للمستقبل.",
      "AI Integration": "تكامل الذكاء الاصطناعي",
      "Cloud Native": "الأنظمة السحابية",
      "Cyber Security": "الأمن السيبراني",
      "IoT Ready": "إنترنت الأشياء",
      Our: "منصاتنا",
      Platforms: "الذكية",
      "Scalable, intelligent, and engineering-driven software solutions designed to modernize industries.":
        "حلول برمجية قابلة للتوسع، ذكية، وموجهة هندسياً صُممت لتطوير الصناعات وتحديثها.",
      "WizResto Platform": "منصة WizResto",
      "Hospitality & F&B": "الضيافة والأغذية والمشروبات",
      "An AI-powered ecosystem for restaurant management, integrating kitchen automation with smart POS systems.":
        "نظام تقني مدعوم بالذكاء الاصطناعي لإدارة المطاعم، يدمج أتمتة المطبخ مع أنظمة نقاط البيع الذكية.",
      "AI Inventory": "مخزون ذكي",
      "Kitchen Display System": "نظام عرض المطبخ",
      "Fleet Tracking": "تتبع الأسطول",
      "WizHealth Connect": "منصة WizHealth",
      "Healthcare Technology": "تكنولوجيا الرعاية الصحية",
      "A secure monitoring platform that bridges medical hardware with cloud data for real-time patient analytics.":
        "منصة مراقبة آمنة تربط الأجهزة الطبية بالبيانات السحابية لتحليل بيانات المرضى في الوقت الفعلي.",
      "Device Connectivity": "اتصال الأجهزة",
      "Data Encryption": "تشفير البيانات",
      "Remote Monitoring": "المراقبة عن بعد",
      "WizBooking SaaS": "نظام WizBooking",
      "Service Sector": "قطاع الخدمات",
      "High-performance booking engine designed for scalable service providers and appointment-based businesses.":
        "محرك حجز عالي الأداء مصمم لمزودي الخدمات القابلين للتوسع والشركات القائمة على المواعيد.",
      "Real-time Availability": "التوفر الفوري",
      "Payment Integration": "ربط المدفوعات",
      "Automated Alerts": "تنبيهات مؤتمتة",
      "Request Demo": "طلب عرض تجريبي",
      "Get in Touch": "تواصل معنا",
      "Have a complex engineering challenge? Let's discuss how WIZ can build your next intelligent system.":
        "هل لديك تحدٍ هندسي معقد؟ دعنا نناقش كيف يمكن لـ WIZ بناء نظامك الذكي القادم.",
      "Contact Information": "معلومات التواصل",
      "Email Us": "راسلنا عبر البريد",
      "Call Us": "اتصل بنا",
      Headquarters: "المقر الرئيسي",
      "Amman, Jordan": "عمان، الأردن",
      "Send a Message": "أرسل رسالة",
      "Your Name": "الاسم الكامل",
      "Email Address": "البريد الإلكتروني",
      Subject: "الموضوع",
      "Project Details / Message": "تفاصيل المشروع / الرسالة",
      "Send Proposal": "إرسال العرض",
      "Get in": "تواصل",
      Touch: "معنا",
admin: {
        products: "المنتجات",
        services: "الخدمات",
        product: " منتج ",
        service:  " خدمة ",
        edit: "تعديل",
        add: " إضافة ",
        name: "الاسم",
        title: "العنوان",
        description: "الوصف",
        features: "المميزات",
        add_feature: "إضافة ميزة",
        image: "صورة المنتج",
        icon: "رمز الأيقونة",
        select_image: "اختر صورة",
        save: "حفظ التغييرات",
        add_btn: "إضافة العنصر",
        published_items: "العناصر المنشورة",
        cancel_edit: "إلغاء التعديل",
        confirm_title: "هل أنت متأكد؟",
        confirm_desc: "لا يمكن التراجع عن هذا الإجراء.",
        cancel: "إلغاء",
        delete_btn: "حذف الآن",
        update_success: "تم التحديث بنجاح! ✨",
        add_success: "تمت الإضافة بنجاح! 🚀",
        delete_success: "تم حذف العنصر 🗑️"
      },
      "Let's Build Together": "دعنا نبني معاً",
      "See Our Work": "شاهد أعمالنا",
      "View Our Work": "عرض أعمالنا",
      "View All Platforms": "عرض جميع المنصات",
      "The engineering stack that powers every WIZ product — from edge AI to immersive XR.": "مجموعة الهندسة التي تشغّل كل منتج WIZ — من الذكاء الاصطناعي الطرفي إلى تجارب XR الغامرة.",
      "Daily Transactions": "المعاملات اليومية",
      "Processed through our intelligent restaurant systems.": "تمت معالجتها عبر أنظمة المطاعم الذكية.",
      "System Uptime": "وقت تشغيل النظام",
      "Reliability for critical healthcare and booking platforms.": "موثوقية لمنصات الرعاية الصحية والحجز الحيوية.",
      "Real-time Monitoring": "المراقبة الفورية",
      "Automated engineering support for all active nodes.": "دعم هندسي مؤتمت لجميع العقد النشطة.",
      "Efficiency Increase": "زيادة الكفاءة",
      "Average productivity boost after AI integration.": "متوسط رفع الإنتاجية بعد تكامل الذكاء الاصطناعي.",
      "Our Products": "منتجاتنا",
    },
  },
  el: {
    translation: {
      Home: "Αρχική",
      Pages: "Σελίδες",
      Services: "Υπηρεσίες",
      Shop: "Κατάστημα",
      Blog: "Ιστολόγιο",
      Contact: "Επικοινωνία",
      "Get in Touch": "Ελάτε σε Επαφή",
      "Modern Technology": "Σύγχρονη Τεχνολογία",
      "Neural Networks": "Νευρωνικά Δίκτυα",
      "AI Agency": "Γραφείο AI",
      Chatbot: "Chatbot",
      Startup: "Startup",
      "AI Consulting": "Συμβουλευτική AI",
      Futurism: "Φουτουρισμός",
      "Hi-Tech": "Υψηλή Τεχνολογία",
      Voiceover: "Εκφώνηση",
      Science: "Επιστήμη",
      "Creative Bureau": "Δημιουργικό Γραφείο",
      "Video Voiceover": "Εκφώνηση Βίντεο",
      "IT Services": "Υπηρεσίες Πληροφορικής",
      "AI Devices": "Συσκευές AI",
      "AI Solutions": "Λύσεις AI",
      "Image Generator": "Γεννήτρια Εικόνων",
      "Content Generator": "Γεννήτρια Περιεχομένου",
      Intro: "Εισαγωγή",
      "About Us": "Σχετικά με Εμάς",
      Team: "Ομάδα",
      "Creative Team": "Δημιουργική Ομάδα",
      "Team Single": "Μέλος Ομάδας",
      Projects: "Έργα",
      "Projects Grid": "Πλέγμα Έργων",
      "Projects Modern": "Σύγχρονα Έργα",
      "Project Single": "Μεμονωμένο Έργο",
      "Gallery Grid": "Πλέγμα Γκαλερί",
      "Gallery Masonry": "Διάταξη Γκαλερί",
      "Pricing Plans": "Πλάνα Τιμολόγησης",
      FAQ: "Συχνές Ερωτήσεις",
      Typography: "Τυπογραφία",
      404: "Σφάλμα 404",
      "Services Page": "Σελίδα Υπηρεσιών",
      "Service Single": "Μεμονωμένη Υπηρεσία",
      Products: "Προϊόντα",
      "Single Product": "Μεμονωμένο Προϊόν",
      "Shopping Cart": "Καλάθι Αγορών",
      Checkout: "Ολοκλήρωση Αγοράς",
      "My Account": "Ο Λογαριασμός μου",
      "Blog Classic": "Κλασικό Ιστολόγιο",
      "Blog Grid": "Πλέγμα Ιστολογίου",
      "Blog Single": "Μεμονωμένο Άρθρο",
      Arabic: "Αραβικά",
      English: "Αγγλικά",
      Greek: "Ελληνικά",
      "Transform Your Business WIZLY": "Μεταμορφώστε την επιχείρησή σας WIZLY",
      "WIZ is a privately owned Palestinian company specialized in IT & AI solution.At WIZ, we are facilitating other’s life and make it easier to achieve their business & personal goals and desires.":
        "Η WIZ είναι μια ιδιωτική παλαιστινιακή εταιρεία που ειδικεύεται σε λύσεις πληροφορικής και τεχνητής νοημοσύνης.",
      "WIZ TECH: Innovation Unleashed": "WIZ TECH: Καινοτομία Χωρίς Όρια",
      "Research per year": "Έρευνα ανά έτος",
      "Explore more": "Εξερευνήστε περισσότερα",
      "[Empowering businesses": "Ενδυνάμωση επιχειρήσεων",
      "with smart IT solutions]": "με έξυπνες λύσεις πληροφορικής]",
      "Key benefits and competitive advantages of our service":
        "Βασικά οφέλη και ανταγωνιστικά πλεονεκτήματα της υπηρεσίας μας",
      "The unique selling points & advantages of our service":
        "Τα μοναδικά σημεία πώλησης και τα πλεονεκτήματα της υπηρεσίας μας",
      "AI Technology": "Τεχνολογία AI",
      "Emphasize the expertise and knowledge of your team in developing and implementing neural networks":
        "Δώστε έμφαση στην εμπειρία και τις γνώσεις της ομάδας σας στην ανάπτυξη και εφαρμογή νευρωνικών δικτύων",
      "Tailored solutions": "Εξατομικευμένες λύσεις",
      "Mention your ability to customize solutions based on specific business requirements":
        "Αναφέρετε την ικανότητά σας να προσαρμόζετε λύσεις βάσει συγκεκριμένων επιχειρηματικών απαιτήσεων",
      "Latest Tools & Techniques": "Τελευταία Εργαλεία & Τεχνικές",
      "Highlight your use of the latest tools and techniques in neural network development":
        "Αναδείξτε τη χρήση των πιο σύγχρονων εργαλείων και τεχνικών στην ανάπτυξη νευρωνικών δικτύων",
      "Showcase successful case studies or client testimonials":
        "Παρουσιάστε επιτυχημένες μελέτες περιπτώσεων ή μαρτυρίες πελατών που αποδεικνύουν την αποτελεσματικότητα των υπηρεσιών σας",
      "Showcase successful case studies or client testimonials that demonstrate the effectiveness of your services":
        "Παρουσιάστε επιτυχημένες μελέτες περιπτώσεων ή μαρτυρίες πελατών που αποδεικνύουν την αποτελεσματικότητα των υπηρεσιών σας",
      "The Neural Network experts: uniting talent for intelligent solutions":
        "Οι ειδικοί των Νευρωνικών Δικτύων: ενώνοντας ταλέντο για έξυπνες λύσεις",
      "Awesome team members": "Εκπληκτικά μέλη της ομάδας",
      Manager: "Διευθυντής",
      "CEO Neuro": "Διευθύνων Σύμβουλος Neuro",
      "HR Neuro": "Ανθρώπινο Δυναμικό Neuro",
      "AI Programmer": "Προγραμματιστής AI",
      "Introducing innovative ideas for business":
        "Εισαγωγή καινοτόμων ιδεών για επιχειρήσεις",
      "User stories: hear what others love about our":
        "Ιστορίες χρηστών: ακούστε τι αγαπούν οι άλλοι για εμάς",
      "WordPress themes": "Θέματα WordPress",
      "Exploring the world of artificial intelligence with Aiero blogging":
        "Εξερευνώντας τον κόσμο της τεχνητής νοημοσύνης με το ιστολόγιο Aiero",
      "Our trusted collaborators in progress and success":
        "Οι έμπιστοι συνεργάτες μας στην πρόοδο και την επιτυχία",
      "Join Aiero and increase your productivity":
        "Γίνετε μέλος της Aiero και αυξήστε την παραγωγικότητά σας",
      "Get a Quote": "Λάβετε Προσφορά",
      "Case Studies": "Μελέτες Περιπτώσεων",
      nav_home: "Αρχική",
      nav_services: "Υπηρεσίες",
      nav_products: "Προϊόντα",
      nav_case_studies: "Μελέτες Περίπτωσης",
      nav_contact: "Επικοινωνία",
      btn_get_in_touch: "Επικοινωνήστε Μαζί Μας",
      "Explore Solutions": "Εξερευνήστε Λύσεις",
      "View Our Platforms": "Δείτε τις Πλατφόρμες μας",
      "Who We Are": "Ποιοι Είμαστε",
      "WIZ is a technology engineering company specializing in building intelligent, scalable, and connected systems. We combine artificial intelligence, software engineering, automation, and smart device integration to help organizations modernize their operations. Our work bridges the gap between software and hardware to deliver complete digital systems.":
        "Η WIZ είναι μια εταιρεία τεχνολογικής μηχανικής που ειδικεύεται στην κατασκευή έξυπνων, επεκτάσιμων και συνδεδεμένων συστημάτων. Συνδυάζουμε την τεχνητή νοημοσύνη, τη μηχανική λογισμικού, τον αυτοματισμό και την ενσωμάτωση έξυπνων συσκευών για να βοηθήσουμε τους οργανισμούς να εκσυγχρονίσουν τις λειτουργίες τους. Το έργο μας γεφυρώνει το χάσμα μεταξύ λογισμικού και υλικού για την παροχή ολοκληρωμένων ψηφιακών συστημάτων.",
      "Number of systems delivered": "Αριθμός παραδοθέντων συστημάτων",
      "Programming &development": "Προγραμματισμός & ανάπτυξη",
      "Achievements of our startup": "Επιτεύγματα της νεοφυούς επιχείρησής μας",
      "Wize Tech": "Wize Tech",
      "Active users every day": "Ενεργοί χρήστες καθημερινά",
      "Professional team & tech": "Επαγγελματική ομάδα & τεχνολογία",
      "Watch Video": "Παρακολουθήστε Βίντεο",
      "Our Platforms": "Οι Πλατφόρμες μας",
      "Restaurant AI System": "Σύστημα AI Εστιατορίου",
      "Hospital Monitoring Platform": "Πλατφόρμα Παρακολούθησης Νοσοκομείου",
      "Booking SaaS Platform": "Πλατφόρμα Κρατήσεων SaaS",
      "Pioneering future-proof engineering with WIZ expertise":
        "Πρωτοποριακή μηχανική με εμπειρία WIZ",
      "CORE SERVICE / INFRASTRUCTURE": "ΚΥΡΙΑ ΥΠΗΡΕΣΙΑ / ΥΠΟΔΟΜΗ",
      "Scalable Cloud Infrastructure for Global Enterprises":
        "Κλιμακούμενη Υποδομή Νέφους για Παγκόσμιες Επιχειρήσεις",
      "Building resilient, high-availability environments that scale automatically with your business traffic.":
        "Δημιουργώντας ανθεκτικά, υψηλής διαθεσιμότητας περιβάλλοντα που κλιμακώνονται αυτόματα με την κυκλοφορία της επιχείρησής σας.",
      "INNOVATION / MODERNIZATION": "ΚΑΙΝΟΤΟΜΙΑ / ΜΟΝΤΕΡΝΙΣΜΟΣ",
      "Modernizing Legacy Systems with Intelligent AI Layers":
        "Εκσυγχρονισμός Παρωχημένων Συστημάτων με Έξυπνα Στρώματα AI",
      "Integrating advanced AI algorithms into existing workflows to boost operational speed by 200%.":
        "Ενσωμάτωση προηγμένων αλγορίθμων AI σε υπάρχοντα ροές εργασίας για αύξηση της ταχύτητας λειτουργίας κατά 200%.",

      "Legacy Systems": "Παρωχημένα Συστήματα",
      "AI Models": "Μοντέλα AI",
      "Cloud Computing": "Υπολογιστικό Νέφος",
      DevOps: "DevOps",
      "Core Technologies": " Κύριες Τεχνολογίες",
      "AI & Machine Learning": " Τεχνητή Νοημοσύνη & Μηχανική Μάθηση",
      "Developing intelligent models for prediction, computer vision, natural language processing, and automated decision-making systems.":
        " Ανάπτυξη έξυπνων μοντέλων για πρόβλεψη, υπολογιστική όραση, επεξεργασία φυσικής γλώσσας και αυτοματοποιημένα συστήματα λήψης αποφάσεων.",

      "Mobile Application Engineering": " Μηχανική Εφαρμογών Κινητών",
      "High-performance Android and iOS applications built on reliability, scalability, and a seamless user experience.":
        " Εφαρμογές Android και iOS υψηλής απόδοσης που βασίζονται σε αξιοπιστία, κλιμακωσιμότητα και απρόσκοπτη εμπειρία χρήστη.",
      "Web & Cloud Platforms": " Πλατφόρμες Ιστού & Νέφους",
      "Secure and scalable web systems, control panels, and cloud backends manage workflows in organizations.":
        " Ασφαλή και κλιμακούμενα συστήματα ιστού, πίνακες ελέγχου και υποδομές νέφους διαχειρίζονται ροές εργασίας σε οργανισμούς.",
      "Automation Systems": " Συστήματα Αυτοματοποίησης",
      "Automating business processes, improving workflow, and coordinating intelligent systems":
        " Αυτοματοποίηση επιχειρηματικών διαδικασιών, βελτίωση ροής εργασίας και συντονισμός έξυπνων συστημάτων",
      "IoT & Robotics Integration": " Ενσωμάτωση IoT & Ρομποτικής",
      "Connected devices, sensor networks, and robotic solutions enable intelligent monitoring and control.":
        " Συνδεδεμένες συσκευές, δίκτυα αισθητήρων και ρομποτικές λύσεις που επιτρέπουν έξυπνη παρακολούθηση και έλεγχο.",
      "AR / VR Experiences": " Εμπειρίες AR / VR",
      "Immersive digital environments for training, visualization, and active user interaction":
        " Βυθιστικά ψηφιακά περιβάλλοντα για εκπαίδευση, οπτικοποίηση και ενεργή αλληλεπίδραση χρήστη",
      "How We Work": " Πώς Εργαζόμαστε",
      "View Our Capabilities": " Δείτε τις Ικανότητές μας ",

      "01. Discover": "01. Ανακάλυψη",
      "We begin with a deep dive into your business needs and technical challenges to identify ideal opportunities for innovation.":
        " Ξεκινάμε με μια βαθιά ανάλυση των επιχειρηματικών σας αναγκών και των τεχνικών προκλήσεων για να εντοπίσουμε ιδανικές ευκαιρίες για καινοτομία.",
      "02. Architect": "02. το σχεδιασμό",
      "We design the systems technical blueprint, focusing on scalability and the seamless connection between software and hardware.":
        "  Σχεδιάζουμε το τεχνικό σχέδιο των συστημάτων, εστιάζοντας στην κλιμακωσιμότητα και τη χωρίς ραφή σύνδεση μεταξύ λογισμικού και υλικού.",
      "03. Engineer": "03. την μηχανική",
      "The actual building phase using cutting-edge AI, IoT, and robotics technologies with the highest engineering standards.":
        " Η πραγματική φάση κατασκευής χρησιμοποιώντας τεχνολογίες αιχμής AI, IoT και ρομποτικής με τα υψηλότερα πρότυπα μηχανικής.",
      "04. Deploy": "04. την εφαρμογή",
      "Launching the system into the real-world environment while ensuring smooth integration with your existing operations.":
        " Εκκίνηση του συστήματος στο πραγματικό περιβάλλον, διασφαλίζοντας ομαλή ενσωμάτωση με τις υπάρχουσες λειτουργίες σας.",
      "05. Optimize": "05. το βελτιστοποίηση",
      "Continuous monitoring and data-driven improvements to ensure your system maintains peak performance and sustainability.":
        " Συνεχής παρακολούθηση και βελτιώσεις με βάση τα δεδομένα για να διασφαλιστεί ότι το σύστημά σας διατηρεί κορυφαία απόδοση και βιωσιμότητα.",

      "Our Engineering": " Η Μηχανική μας",
      "Impact in Numbers": "Επίδραση σε Αριθμούς",
      "We don't just build software; we engineer high-performance ecosystems that power industries.":
        " Δεν κατασκευάζουμε απλώς λογισμικό· αντίθετα, ενσωματώνουμε υψηλότερη απόδοση συστήματα που δύνανται τις βιομηχανίες.",

      "Trusted by Industry": " Εμπιστευόμενο από την Βιομηχανία",
      Leaders: " Ηγέτες",
      "Powering operations for global enterprises and innovative startups.":
        " Προσφέρουμε υποστήριξη λειτουργιών για παγκόσμιες επιχειρήσεις και καινοτόμες εταιρίες.",

      "Ready to build something intelligent?":
        "Έτοιμοι να δημιουργήσετε κάτι έξυπνο;",
      "Start a Project": "Ξεκινήστε ένα Έργο",
      "All rights reserved.": "Όλα τα δικαιώματα διατηρούνται.",

      "Start a Project": "Ξεκινήστε ένα Έργο",
      "All rights reserved.": "Όλα τα δικαιώματα διατηρούνται.",
      "Dubai, United Arab Emirates": "Ντουμπάι, Ηνωμένα Αραβικά Εμιράτα",
      "Tech Hub, Silicon Oasis": "Κέντρο Τεχνολογίας, Silicon Oasis",
      "Follow Us": "Ακολουθήστε μας",
      X: "X",
      Instagram: "Instagram",
      "Let's Talk": "Ας Μιλήσουμε",
      Expertise: "Εξειδίκευση",
      "Our Platforms": "Οι Πλατφόρμες μας",
      Engineering: "Μηχανική",
      "Case Studies": "Μελέτες Περίπτωσης",
      Contact: "Επικοινωνία",
      Headquarters: "Έδρα",
      Email: "Ηλεκτρονικό Ταχυδρομείο",
      "Engineering Excellence": "Αριστεία στη Μηχανική",
      "Our Impact": "Ο Αντίκτυπός Μας",
      Case: "Μελέτες",
      Studies: "Περίπτωσης",
      "Real-world engineering challenges met with intelligent, scalable solutions.":
        "Πραγματικές μηχανολογικές προκλήσεις που αντιμετωπίστηκαν με έξυπνες, επεκτάσιμες λύσεις.",
      "Kitchen Workflow Optimization": "Βελτιστοποίηση Ροής Εργασιών Κουζίνας",
      "Global Food Chain": "Παγκόσμια Αλυσίδα Τροφίμων",
      "Predictive Patient Monitoring": "Προγνωστική Παρακολούθηση Ασθενών",
      "City General Hospital": "Γενικό Νοσοκομείο Πόλης",
      "SaaS Booking Infrastructure": "Υποδομή Κρατήσεων SaaS",
      "Travel Tech Startup": "Travel Tech Startup",
      Client: "Πελάτης",
      Impact: "Αντίκτυπος",
      "Read Full Study": "Διαβάστε την Πλήρη Μελέτη",
      "Ready to build your success story?":
        "Είστε έτοιμοι να δημιουργήσετε τη δική σας ιστορία επιτυχίας;",
      "Join our list of high-impact engineering partners.":
        "Γίνετε μέλος της λίστας των μηχανολογικών συνεργατών υψηλού αντικτύπου.",
      "Start a Project": "Ξεκινήστε ένα Έργο",
      "2M+ Transactions/Mo": "2M+ Συναλλαγές/Μήνα",
      "99.9% Uptime": "99.9% Χρόνος Λειτουργίας",
      "40% Efficiency Boost": "40% Αύξηση Αποδοτικότητας",
      Automation: "Αυτοματισμός",
      "AI & Data": "AI & Δεδομένα",
      "Cloud Systems": "Συστήματα Νέφους",

      "Our Expertise": "Η Εμπειρία Μας",
      Engineering: "Μηχανολογικές",
      Solutions: "Λύσεις",
      "Restaurant AI Ecosystem": "Οικοσύστημα AI Εστιατορίων",
      "A complete autonomous system integrating POS, kitchen automation, and AI-driven inventory management for modern hospitality.":
        "Ένα πλήρες αυτόνομο σύστημα που ενσωματώνει POS, αυτοματισμό κουζίνας και διαχείριση αποθεμάτων με τεχνητή νοημοσύνη.",
      "Automated Ordering": "Αυτοματοποιημένη Παραγγελιοληψία",
      "Inventory AI": "AI Αποθεμάτων",
      "Fleet Management": "Διαχείριση Στόλου",
      "Healthcare Monitoring Platform": "Πλατφόρμα Παρακολούθησης Υγείας",
      "Next-generation hospital systems connecting medical devices with real-time data analytics for critical patient care.":
        "Νοσοκομειακά συστήματα επόμενης γενιάς που συνδέουν ιατρικές συσκευές με ανάλυση δεδομένων σε πραγματικό χρόνο.",
      "Device Integration": "Ενσωμάτωση Συσκευών",
      "Real-time Analytics": "Ανάλυση σε Πραγματικό Χρόνο",
      "Data Security": "Ασφάλεια Δεδομένων",
      "Smart Booking SaaS": "Έξυπνο Σύστημα Κρατήσεων SaaS",
      "Scalable cloud infrastructure designed to handle high-concurrency bookings for global service providers.":
        "Επεκτάσιμη υποδομή cloud σχεδιασμένη για το χειρισμό κρατήσεων υψηλής ταυτόχρονης χρήσης.",
      "Cloud Scalability": "Επεκτασιμότητα Cloud",
      "Multi-tenant Architecture": "Αρχιτεκτονική Multi-tenant",
      "Advanced API": "Προηγμένο API",
      "The Technical Advantage": "Το Τεχνικό Πλεονέκτημα",
      "We don't just build apps; we architect resilient infrastructures. Using a modern stack of AI, IoT, and Cloud-native technologies, we ensure your system is future-proof.":
        "Δεν κατασκευάζουμε μόνο εφαρμογές. σχεδιάζουμε ανθεκτικές υποδομές χρησιμοποιώντας AI, IoT και Cloud τεχνολογίες.",
      "AI Integration": "Ενσωμάτωση AI",
      "Cloud Native": "Cloud Native",
      "Cyber Security": "Κυβερνοασφάλεια",
      "IoT Ready": "Έτοιμο για IoT",
      Our: "Οι",
      Platforms: "Πλατφόρμες μας",
      "Scalable, intelligent, and engineering-driven software solutions designed to modernize industries.":
        "Επεκτάσιμες, έξυπνες και μηχανολογικά προηγμένες λύσεις λογισμικού σχεδιασμένες για τον εκσυγχρονισμό των βιομηχανιών.",
      "WizResto Platform": "Πλατφόρμα WizResto",
      "Hospitality & F&B": "Φιλοξενία & Εστίαση",
      "An AI-powered ecosystem for restaurant management, integrating kitchen automation with smart POS systems.":
        "Ένα οικοσύστημα με υποστήριξη AI για τη διαχείριση εστιατορίων, που ενσωματώνει αυτοματισμό κουζίνας με έξυπνα συστήματα POS.",
      "AI Inventory": "AI Διαχείριση Αποθεμάτων",
      "Kitchen Display System": "Σύστημα Προβολής Κουζίνας",
      "Fleet Tracking": "Παρακολούθηση Στόλου",
      "WizHealth Connect": "WizHealth Connect",
      "Healthcare Technology": "Τεχνολογία Υγείας",
      "A secure monitoring platform that bridges medical hardware with cloud data for real-time patient analytics.":
        "Μια ασφαλής πλατφόρμα παρακολούθησης που συνδέει ιατρικό εξοπλισμό με δεδομένα cloud για ανάλυση ασθενών σε πραγματικό χρόνο.",
      "Device Connectivity": "Συνδεσιμότητα Συσκευών",
      "Data Encryption": "Κρυπτογράφηση Δεδομένων",
      "Remote Monitoring": "Απομακρυσμένη Παρακολούθηση",
      "WizBooking SaaS": "WizBooking SaaS",
      "Service Sector": "Τομέας Υπηρεσιών",
      "High-performance booking engine designed for scalable service providers and appointment-based businesses.":
        "Μηχανή κρατήσεων υψηλής απόδοσης σχεδιασμένη για επεκτάσιμους παρόχους υπηρεσιών.",
      "Real-time Availability": "Διαθεσιμότητα σε Πραγματικό Χρόνο",
      "Payment Integration": "Ενσωμάτωση Πληρωμών",
      "Automated Alerts": "Αυτοματοποιημένες Ειδοποιήσεις",
      "Request Demo": "Ζητήστε Επίδειξη",
      "Get in Touch": "Επικοινωνήστε Μαζί Μας",
      "Have a complex engineering challenge? Let's discuss how WIZ can build your next intelligent system.":
        "Έχετε μια σύνθετη μηχανολογική πρόκληση; Ας συζητήσουμε πώς η WIZ μπορεί να κατασκευάσει το επόμενο έξυπνο σύστημά σας.",
      "Contact Information": "Πληροφορίες Επικοινωνίας",
      "Email Us": "Στείλτε μας Email",
      "Call Us": "Καλέστε Μας",
      Headquarters: "Έδρα",
      "Amman, Jordan": "Αμμάν, Ιορδανία",
      "Send a Message": "Στείλτε ένα Μήνυμα",
      "Your Name": "Το Όνομά Σας",
      "Email Address": "Διεύθυνση Email",
      Subject: "Θέμα",
      "Project Details / Message": "Λεπτομέρειες Έργου / Μήνυμα",
      "Send Proposal": "Αποστολή Πρότασης",
      "Get in": "",
      Touch: "",
      "admin": {
        "add_btn":"Προσθήκη Νέου",
      "products": "Προϊόντα",
    "services": "Υπηρεσίες",
    "edit_content": "Επεξεργασία Περιεχομένου",
    "add_new": "Προσθήκη Νέου Περιεχομένου",
    "cancel_edit": "Ακύρωση Επεξεργασίας",
    "name": "Όνομα",
    "title": "Τίτλος",
    "description": "Περιγραφή",
    "features": "Πίνακας Χαρακτηριστικών",
    "add_feature": "+ Προσθήκη Χαρακτηριστικού",
    "save_changes": "Αποθήκευση Αλλαγών",
    "add_to_db": "Προσθήκη στη Βάση",
    "published_items": "Δημοσιευμένα Στοιχεία",
    "confirm_delete": "Οριστική διαγραφή;"
    },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

// تغيير اتجاه الصفحة تلقائياً عند تغيير اللغة
i18n.on("languageChanged", (lng) => {
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lng;
});

export default i18n;
